import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useTheme, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_SCRN_MGMT, SG_SCRN_LANG_LIST, URLS } from "@/tz/go/egaz/osci/ptl/ptl/scrn/services/OsciScrnService";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const OSCI0104006S = (): JSX.Element => {
    const {} = usePage({
        auth: ["auth_osci0003"],
    });
    const toast = useToast();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const modal = useModal();
    const { scrnId } = useParams();
    const langCodes = ["KO", "EN", "TZ"];

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = { scrnMgmt: useForm({ defaultSchema: SF_SCRN_MGMT }) };

    const grid = { scrnLangList: useGrid({ defaultSchema: SG_SCRN_LANG_LIST }) };

    const fetch = {
        getScrnDtl: useFetch({
            api: (data: any) => APIS.getScrnDtl(data),
            onSuccess: (data: any) => {
                const { scrnDtl } = data;
                if (comnUtils.isEmpty(scrnDtl.content)) {
                    modal.openModal({ content: "msg.osc.00201" }); // Abnormal access. !== 비정상 접근입니다. ==!
                    handler.onListBtnClick();
                    return;
                }

                const scrnLangList = scrnDtl.content.scrnLangList;
                scrnLangList.forEach((item: any) => {
                    form.scrnMgmt.setValue(`scrnNm${item.langCd}`, item.scrnNm);
                    form.scrnMgmt.setValue(`scrnDesc${item.langCd}`, item.scrnDesc);
                });

                form.scrnMgmt.setValues(scrnDtl.content);
                form.scrnMgmt.setEditable("scrnUrlAddr", true);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // 조회가 실패하였습니다.
        }),
        saveScrnDtl: useFetch({
            api: () => APIS.saveScrnDtl({ ...form.scrnMgmt.getValues(), scrnLangList: grid.scrnLangList.getData() }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00073",
                    close: false,
                    onConfirm: () => {
                        handler.onListBtnClick();
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00045" }), // 저장이 실패하였습니다.
        }),
        deleteScrnDtl: useFetch({
            api: () => APIS.deleteScrnDtl(scrnId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071",
                    close: false,
                    onConfirm: () => {
                        handler.onListBtnClick();
                    },
                });
            },
            onError: (error: any) => {
                const { errorMessage } = error.response.data;
                modal.openModal({ content: errorMessage });
            },
        }),
    };

    const handler = {
        onSaveBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00058", // 저장하시겠습니까?
                onConfirm: () => {
                    form.scrnMgmt.handleSubmit(
                        () => {
                            grid.scrnLangList.clearData();

                            langCodes.forEach((langCd) => {
                                const scrnId = form.scrnMgmt.getValue("scrnId");
                                const scrnNm = form.scrnMgmt.getValue(`scrnNm${langCd}`);
                                const scrnDesc = form.scrnMgmt.getValue(`scrnDesc${langCd}`);
                                grid.scrnLangList.addRow({
                                    langCd: langCd,
                                    scrnNm: scrnNm,
                                    scrnDesc: scrnDesc,
                                    scrnId: scrnId,
                                });
                            });
                            fetch.saveScrnDtl.fetch();
                        },
                        () => toast.showToast({ content: "msg.osc.00195" }), // 필수 입력 항목을 입력하시기 바랍니다.
                    )();
                },
            });
        },
        onDelBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteScrnDtl.fetch(),
            });
        },
        onListBtnClick: () => navigate(`${URLS.osci0104004q}`),
    };

    useEffect(() => {
        form.scrnMgmt.setSchema("bsopClsfCd", { required: false, edit: false });
        form.scrnMgmt.setSchema("ptlTpCd", { required: false, edit: false });
        form.scrnMgmt.setSchema("scrnId", { required: false, edit: false });
        form.scrnMgmt.setSchema("scrnDefnDocId", { required: false, edit: false });
        console.log("11111111111111111111111111111111111111");
        console.log("11111111111111111111111111111111111111");
        console.log("11111111111111111111111111111111111111");
        console.log("11111111111111111111111111111111111111");
        console.log("11111111111111111111111111111111111111");
        fetch.getScrnDtl.fetch(scrnId);
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnDefnDocId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnNmTZ} />
                            <Group.Control {...form.scrnMgmt.schema.scrnDescTZ} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnNmEN} />
                            <Group.Control {...form.scrnMgmt.schema.scrnDescEN} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmt.schema.scrnNmKO} />
                            <Group.Control {...form.scrnMgmt.schema.scrnDescKO} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section hidden={true}>
                        {" "}
                        <Grid {...grid.scrnLangList.grid} />{" "}
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDelBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
